// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TaskHeader-module__HeaderContainer__1hqef{display:flex;align-items:center;justify-content:space-between;padding:10px 16px;border-bottom:1px solid #e5e7eb;background-color:#fff;font-family:\"Inter\",sans-serif}.TaskHeader-module__TitleGroup__2fJO9{display:flex;align-items:center;gap:8px}.TaskHeader-module__Title__1BeGU{font-size:14px;font-weight:600;color:#111827}.TaskHeader-module__HitTypeBadge__3QwFG{padding:2px 8px;border-radius:4px;background-color:#fef9c3;color:#854d0e;font-size:11px;font-weight:500;border:1px solid #fde68a;margin:0px;line-height:14px}.TaskHeader-module__Timestamp__eLzMp{font-size:11px;color:#9ca3af;font-weight:400}", ""]);
// Exports
exports.locals = {
	"HeaderContainer": "TaskHeader-module__HeaderContainer__1hqef",
	"TitleGroup": "TaskHeader-module__TitleGroup__2fJO9",
	"Title": "TaskHeader-module__Title__1BeGU",
	"HitTypeBadge": "TaskHeader-module__HitTypeBadge__3QwFG",
	"Timestamp": "TaskHeader-module__Timestamp__eLzMp"
};
export default exports;
